// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"styles_cardContent__2EGiC"};